// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#verifier {\n  padding-bottom: env(safe-area-inset-bottom);\n}\n@media screen and (max-width: 650px) {\n#verifier.camera {\n    margin-bottom: 84px;\n}\n}", ""]);
// Exports
module.exports = exports;
